import React from 'react';
import { DeviceProvider } from './Device/DeviceProvider';
import { LayoutProvider } from './App/Layout/LayoutProvider';
import { UserProvider } from './App/User/UserProvider';
import { StoreProvider } from './App/Store/StoreProvider';
import { OrdersProvider } from './App/Orders/OrdersProvider';

const Provider = ({ children }) => {
  return (
    <DeviceProvider>
      <LayoutProvider>
        <UserProvider>
          <StoreProvider>
            <OrdersProvider>
              {children}
            </OrdersProvider>
          </StoreProvider>
        </UserProvider>
      </LayoutProvider>
    </DeviceProvider>
  );
};

export default Provider;